var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2e3546",
    d: "M6 7.471c1.964 0 5.885.986 5.885 2.943v1.47H.115v-1.47C.115 8.457 4.036 7.47 6 7.47zm2.942-4.413a2.942 2.942 0 1 1-5.884 0 2.942 2.942 0 1 1 5.884 0zM6 8.942c-1.979 0-4.244.942-4.414 1.472h8.828C10.266 9.89 7.986 8.942 6 8.942m0-7.356c-.81 0-1.471.663-1.471 1.472 0 .809.662 1.47 1.471 1.47.81 0 1.471-.661 1.471-1.47 0-.81-.662-1.472-1.471-1.472"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.98be644339198ad90ddbccbe9c8d884c.svg";
export { ForwardRef as ReactComponent };